import * as types from './types';

export const generalMutations = {
  [types.GENERAL_DATA.SET.ALL] (state, payload) {
    state.generalData = payload;
  }
}